import React from "react";
import { usePlayer } from "../operators/PlayerOperator.jsx";
const FloatingCardComponent = ({onDisconnect}) => {

  const { username, uuid } = usePlayer();

  const avatarURL = `https://visage.surgeplay.com/bust/500/${encodeURIComponent(uuid)}`;

  return (
    <div className="w-[65%] mx-auto bg-gray-800/80 text-white shadow-lg rounded-xl p-4 flex items-center justify-between -translate-y-6 backdrop-blur-md border border-white/10">

      <div className="flex items-center gap-3">
        <img
          src={avatarURL}
          alt="Player Avatar"
          className="w-11 h-11 rounded-lg shadow-md"
        />

        <div>
          <h2 className="text-base font-semibold tracking-wide">Connected!</h2>
          <p className="text-xs text-gray-300">Identified as {username}</p>
        </div>
      </div>

      <button
        onClick={onDisconnect}
        className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded-md shadow-md transition text-sm"
      >
        Disconnect
      </button>
    </div>
  );
};

export default FloatingCardComponent;

